import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

const SharedReport = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [reportUrl, setReportUrl] = useState('');

    useEffect(() => {
        const fetchReport = async () => {
            try {
                const backendUrl = process.env.NODE_ENV === 'development'
                    ? 'http://localhost:5000'
                    : window.location.origin;

                const url = `${backendUrl}/api/reports/shared/${token}`;
                setReportUrl(url);
                setLoading(false);
            } catch (err) {
                setError(t('analyses.errorLoading'));
                setLoading(false);
            }
        };

        fetchReport();
    }, [token, t]);

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="container py-5">
                <div className="alert alert-danger">{error}</div>
                <button onClick={() => navigate('/')} className="btn btn-primary">
                    <i className="fas fa-arrow-right me-2"></i>
                    {t('nav.home')}
                </button>
            </div>
        );
    }

    return (
        <div style={{ width: '100%', height: '100vh', display: 'flex', flexDirection: 'column' }}>
            {/* Header with Back Button */}
            <div style={{
                padding: '15px 20px',
                backgroundColor: '#ffffff',
                borderBottom: '1px solid #e0e0e0',
                display: 'flex',
                alignItems: 'center',
                gap: '15px'
            }}>
                <button
                    onClick={() => navigate(-1)}
                    className="btn btn-light"
                    style={{
                        border: '1px solid #dee2e6',
                        borderRadius: '8px',
                        padding: '8px 16px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    }}
                >
                    <i className={`fas ${i18n.dir() === 'rtl' ? 'fa-arrow-right' : 'fa-arrow-left'}`}></i>
                    <span>{t('sharedReport.back', 'عودة')}</span>
                </button>
                <h5 className="mb-0" style={{ color: '#333' }}>{t('sharedReport.title', 'عرض التحليل الطبي')}</h5>
            </div>

            {/* PDF Viewer */}
            <iframe
                src={reportUrl}
                style={{
                    width: '100%',
                    height: '100%',
                    border: 'none',
                    flex: 1
                }}
                title={t('sharedReport.title', 'Medical Report')}
            />
        </div>
    );
};

export default SharedReport;
